'use strict';

angular.module('far.news')
    .controller('NewsViewController', function($log, FileUploader, News, fileUploadFilters, showModalMessage, $uibModal) {
        var showFilterError = false;

        var vm = {
            progress: true,
            initNews: initNews,
            openSlider: openSlider
        };

        function initNews(id) {
            vm.news = News.getView(id, function () {
                vm.progress = false;
            });
        }

        function openSlider(slide) {
            $uibModal.open({
                templateUrl: '/modals/slider/slider.html',
                controller: 'SliderController as slider',
                resolve: {
                    slides: function() {
                        return vm.news.slides_files;
                    },
                    selectedSlide: function() {
                        return slide;
                    }
                }
            });
        }

        return vm;
    });
